import { useCallback, useMemo } from "react"
import {
  trackMetricsSelectorOpened,
  trackMetricsSelectorClosed,
  trackMetricSelected,
  trackMetricDeselected,
  trackMetricsSelectorSearchPerformed,
  trackMetricsCategoryExpanded,
  trackMetricsCategoryCollapsed,
  trackCustomViewSaved,
  trackCustomViewUpdated,
  trackCustomViewDeleted,
  trackMetricsSelectorPermissionsClicked,
} from "../analytics"

export function useMetricsSelectorAnalytics(context) {
  const trackOpened = useCallback((templateMetadata = null) => {
    trackMetricsSelectorOpened(context, templateMetadata)
  }, [context])

  const trackClosed = useCallback((templateMetadata = null) => {
    trackMetricsSelectorClosed(context, templateMetadata)
  }, [context])

  const trackMetricToggled = useCallback((metricId, isSelected) => {
    if (isSelected) {
      trackMetricSelected(context, metricId)
    } else {
      trackMetricDeselected(context, metricId)
    }
  }, [context])

  const trackSearchPerformed = useCallback((searchTerm) => {
    trackMetricsSelectorSearchPerformed(context, searchTerm)
  }, [context])

  const trackCategoryExpanded = useCallback((categoryId) => {
    trackMetricsCategoryExpanded(context, categoryId)
  }, [context])

  const trackCategoryCollapsed = useCallback((categoryId) => {
    trackMetricsCategoryCollapsed(context, categoryId)
  }, [context])

  const trackViewSaved = useCallback((viewName, metricsCount) => {
    trackCustomViewSaved(context, viewName, metricsCount)
  }, [context])

  const trackViewUpdated = useCallback((templateId, viewName, metricsCount) => {
    trackCustomViewUpdated(context, templateId, viewName, metricsCount)
  }, [context])

  const trackViewDeleted = useCallback((templateId, viewName) => {
    trackCustomViewDeleted(context, templateId, viewName)
  }, [context])

  const trackPermissionsClicked = useCallback((templateId, viewName) => {
    trackMetricsSelectorPermissionsClicked(context, templateId, viewName)
  }, [context])

  return useMemo(() => ({
    trackOpened,
    trackClosed,
    trackMetricToggled,
    trackSearchPerformed,
    trackCategoryExpanded,
    trackCategoryCollapsed,
    trackViewSaved,
    trackViewUpdated,
    trackViewDeleted,
    trackPermissionsClicked,
  }), [
    trackOpened,
    trackClosed,
    trackMetricToggled,
    trackSearchPerformed,
    trackCategoryExpanded,
    trackCategoryCollapsed,
    trackViewSaved,
    trackViewUpdated,
    trackViewDeleted,
    trackPermissionsClicked,
  ])
}
